import React from 'react';

const SvgSafety = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 512 512" ref={svgRef} {...props} width="1em" height="1em">
    <title>{title}</title>
    <path
      d="M473.5 93.1c-34.7 0-63-27.8-63-62V17H122.3v14c0 34.2-28.3 62-63 62H45v93.3c0 67 20.5 131.6 59.4 186.7 38.8 55.1 93.1 96.6 157 120.2l5 1.9 5-1.9c63.9-23.5 118.2-65.1 157-120.2S488 253.3 488 186.3V93.1h-14.5zm-14.3 93.3h0c0 61.3-18.8 120.3-54.3 170.7-34.5 48.9-82.3 86.2-138.5 107.9-56.2-21.8-104.1-59-138.5-107.9-35.5-50.4-54.3-109.4-54.3-170.7V120c39.1-6.1 70.1-36.5 76.2-75h233.3c6.2 38.5 37.1 68.9 76.2 75l-.1 66.4h0z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={18}
      strokeMiterlimit={10}
    />
    <path fill="currentColor" stroke="currentColor" strokeWidth={18} strokeMiterlimit={10} d="M165.3 256.8l56.2-51.9 29.3 27 84.1-77.5 56.3 51.8-140.4 129.4z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgSafety svgRef={ref} {...props} />);
export default ForwardRef;
